import { AxiosInstance } from "axios";
import FundInterface from "@/types/app/funds";

export async function getFund(url: string, id: string, api: AxiosInstance) {
  const response = await api.get(`${url}${id}`);
  const fund = response.data as FundInterface;
  return fund;
}